import React from 'react';
import PersonAvatar from '../avatar/PersonAvatar';

const getAssigneeId = (assignee) =>
  assignee?.admin_user_id ?? assignee?.adminUserId ?? assignee?.id ?? assignee?.user_id ?? null;

export const getAssigneeDisplayName = (assignee) =>
  assignee?.display_name ||
  assignee?.full_name ||
  assignee?.nickname ||
  assignee?.username ||
  '担当者';

export const normalizeEventAssignees = (assignees) => {
  const list = Array.isArray(assignees) ? assignees : [];
  const seen = new Set();
  return list.filter((assignee) => {
    if (!assignee) return false;
    const rawId = getAssigneeId(assignee);
    const key = rawId == null ? getAssigneeDisplayName(assignee) : String(rawId);
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const isCurrentAdminAssigned = (assignees, currentAdminId) => {
  if (!currentAdminId) return false;
  return normalizeEventAssignees(assignees).some((assignee) => {
    const id = getAssigneeId(assignee);
    return id != null && Number(id) === Number(currentAdminId);
  });
};

const EventAssigneeAvatars = ({
  assignees,
  maxVisible = 4,
  className = '',
  emptyText = '',
}) => {
  const normalized = normalizeEventAssignees(assignees);
  if (!normalized.length) {
    return emptyText ? (
      <div className={`event-assignees event-assignees--empty ${className}`.trim()}>
        <span>{emptyText}</span>
      </div>
    ) : null;
  }

  const visible = normalized.slice(0, maxVisible);
  const rest = normalized.length - visible.length;
  const allNames = normalized.map(getAssigneeDisplayName).join(' / ');

  return (
    <div className={`event-assignees ${className}`.trim()} aria-label={`担当者: ${allNames}`}>
      {visible.map((assignee) => {
        const name = getAssigneeDisplayName(assignee);
        const key = getAssigneeId(assignee) ?? name;
        return (
          <PersonAvatar
            key={String(key)}
            person={assignee}
            role="admin"
            name={name}
            profilePicture={assignee?.profile_picture || assignee?.profilePicture || ''}
            className="event-assignees__avatar"
            title={name}
            size={16}
            ariaHidden
          />
        );
      })}
      {rest > 0 && <span className="event-assignees__more" title={allNames}>+{rest}</span>}
    </div>
  );
};

export default EventAssigneeAvatars;
